/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  EmployeeDirectoryResponseDto,
  EmployeeProfileResponseDto,
  LineManagerCandidateResponseDto,
  SetEmployeePhotoRequestDto,
  UpdateEmployeeAdditionalNotesRequestDto,
  UpdateEmployeeAllergiesRequestDto,
  UpdateEmployeeContactDetailsRequestDto,
  UpdateEmployeeEmergencyContactRequestDto,
  UpdateEmployeeHealthInformationRequestDto,
  UpdateEmployeeKeyInformationRequestDto,
  UpdateEmployeeMedicationRequestDto,
  UpdateEmployeePersonalInformationRequestDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Deputies, managers, group admins and platform admins. Key Information only, never the sensitive sections. Account status and last login are left out for deputies. Capped at 500 rows; `truncated` says when the cap was hit.
 * @summary List the employees at a nursery
 */
export const listEmployeeDirectory = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<EmployeeDirectoryResponseDto>({
    url: `/v1/nurseries/${nurseryId}/people`,
    method: "GET",
    signal,
  });
};

export const getListEmployeeDirectoryQueryKey = (nurseryId: string) => {
  return [`/v1/nurseries/${nurseryId}/people`] as const;
};

export const getListEmployeeDirectoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listEmployeeDirectory>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeeDirectory>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEmployeeDirectoryQueryKey(nurseryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEmployeeDirectory>>
  > = ({ signal }) => listEmployeeDirectory(nurseryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEmployeeDirectory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEmployeeDirectoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEmployeeDirectory>>
>;
export type ListEmployeeDirectoryQueryError = void;

export function useListEmployeeDirectory<
  TData = Awaited<ReturnType<typeof listEmployeeDirectory>>,
  TError = void,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeeDirectory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployeeDirectory>>,
          TError,
          Awaited<ReturnType<typeof listEmployeeDirectory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEmployeeDirectory<
  TData = Awaited<ReturnType<typeof listEmployeeDirectory>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeeDirectory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployeeDirectory>>,
          TError,
          Awaited<ReturnType<typeof listEmployeeDirectory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEmployeeDirectory<
  TData = Awaited<ReturnType<typeof listEmployeeDirectory>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeeDirectory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List the employees at a nursery
 */

export function useListEmployeeDirectory<
  TData = Awaited<ReturnType<typeof listEmployeeDirectory>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeeDirectory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListEmployeeDirectoryQueryOptions(nurseryId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Active managers and deputy managers at the nursery, for the Add Employee form. For callers who can add employees there.
 * @summary Who can be picked as a new employee's line manager
 */
export const listNurseryLineManagerCandidates = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<LineManagerCandidateResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/line-manager-candidates`,
    method: "GET",
    signal,
  });
};

export const getListNurseryLineManagerCandidatesQueryKey = (
  nurseryId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/line-manager-candidates`] as const;
};

export const getListNurseryLineManagerCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListNurseryLineManagerCandidatesQueryKey(nurseryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>
  > = ({ signal }) => listNurseryLineManagerCandidates(nurseryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNurseryLineManagerCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>
>;
export type ListNurseryLineManagerCandidatesQueryError = void;

export function useListNurseryLineManagerCandidates<
  TData = Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
          TError,
          Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseryLineManagerCandidates<
  TData = Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
          TError,
          Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseryLineManagerCandidates<
  TData = Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Who can be picked as a new employee's line manager
 */

export function useListNurseryLineManagerCandidates<
  TData = Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseryLineManagerCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListNurseryLineManagerCandidatesQueryOptions(
    nurseryId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Anyone can view their own profile; deputies, managers, group admins and platform admins can view anyone's at the nursery. Sections the caller may not see come back as null, and `capabilities` says what the caller may do.
 * @summary Get an employee profile
 */
export const getEmployeeProfile = (
  nurseryId: string,
  userId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<EmployeeProfileResponseDto>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}`,
    method: "GET",
    signal,
  });
};

export const getGetEmployeeProfileQueryKey = (
  nurseryId: string,
  userId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/people/${userId}`] as const;
};

export const getGetEmployeeProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeeProfile>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmployeeProfile>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEmployeeProfileQueryKey(nurseryId, userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmployeeProfile>>
  > = ({ signal }) => getEmployeeProfile(nurseryId, userId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      nurseryId !== null &&
      nurseryId !== undefined &&
      userId !== null &&
      userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeeProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEmployeeProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeeProfile>>
>;
export type GetEmployeeProfileQueryError = void;

export function useGetEmployeeProfile<
  TData = Awaited<ReturnType<typeof getEmployeeProfile>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmployeeProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeProfile>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeProfile>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEmployeeProfile<
  TData = Awaited<ReturnType<typeof getEmployeeProfile>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmployeeProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeProfile>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeProfile>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEmployeeProfile<
  TData = Awaited<ReturnType<typeof getEmployeeProfile>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmployeeProfile>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get an employee profile
 */

export function useGetEmployeeProfile<
  TData = Awaited<ReturnType<typeof getEmployeeProfile>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmployeeProfile>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEmployeeProfileQueryOptions(
    nurseryId,
    userId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Managers, group admins and platform admins; never on your own profile. Send every field: null clears one. The photo has its own endpoint and is not changed here.
 * @summary Replace an employee's Key Information
 */
export const updateEmployeeKeyInformation = (
  nurseryId: string,
  userId: string,
  updateEmployeeKeyInformationRequestDto: UpdateEmployeeKeyInformationRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/key-information`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEmployeeKeyInformationRequestDto,
    signal,
  });
};

export const getUpdateEmployeeKeyInformationMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeKeyInformation>>,
    TError,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeKeyInformationRequestDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeeKeyInformation>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeKeyInformationRequestDto;
  },
  TContext
> => {
  const mutationKey = ["updateEmployeeKeyInformation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeeKeyInformation>>,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeKeyInformationRequestDto;
    }
  > = (props) => {
    const { nurseryId, userId, data } = props ?? {};

    return updateEmployeeKeyInformation(nurseryId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeeKeyInformationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeeKeyInformation>>
>;
export type UpdateEmployeeKeyInformationMutationBody =
  UpdateEmployeeKeyInformationRequestDto;
export type UpdateEmployeeKeyInformationMutationError = void;

/**
 * @summary Replace an employee's Key Information
 */
export const useUpdateEmployeeKeyInformation = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeeKeyInformation>>,
      TError,
      {
        nurseryId: string;
        userId: string;
        data: UpdateEmployeeKeyInformationRequestDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeKeyInformation>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeKeyInformationRequestDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateEmployeeKeyInformationMutationOptions(options),
    queryClient,
  );
};
/**
 * Managers, group admins and platform admins; never on your own profile. Send every field: null clears one. The NI number is stored compact and in capitals.
 * @summary Replace an employee's Personal Information
 */
export const updateEmployeePersonalInformation = (
  nurseryId: string,
  userId: string,
  updateEmployeePersonalInformationRequestDto: UpdateEmployeePersonalInformationRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/personal-information`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEmployeePersonalInformationRequestDto,
    signal,
  });
};

export const getUpdateEmployeePersonalInformationMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeePersonalInformation>>,
    TError,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeePersonalInformationRequestDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeePersonalInformation>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeePersonalInformationRequestDto;
  },
  TContext
> => {
  const mutationKey = ["updateEmployeePersonalInformation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeePersonalInformation>>,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeePersonalInformationRequestDto;
    }
  > = (props) => {
    const { nurseryId, userId, data } = props ?? {};

    return updateEmployeePersonalInformation(nurseryId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeePersonalInformationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeePersonalInformation>>
>;
export type UpdateEmployeePersonalInformationMutationBody =
  UpdateEmployeePersonalInformationRequestDto;
export type UpdateEmployeePersonalInformationMutationError = void;

/**
 * @summary Replace an employee's Personal Information
 */
export const useUpdateEmployeePersonalInformation = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeePersonalInformation>>,
      TError,
      {
        nurseryId: string;
        userId: string;
        data: UpdateEmployeePersonalInformationRequestDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeePersonalInformation>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeePersonalInformationRequestDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateEmployeePersonalInformationMutationOptions(options),
    queryClient,
  );
};
/**
 * Managers, group admins and platform admins; never on your own profile. Send every field: null clears one.
 * @summary Replace an employee's Contact Details
 */
export const updateEmployeeContactDetails = (
  nurseryId: string,
  userId: string,
  updateEmployeeContactDetailsRequestDto: UpdateEmployeeContactDetailsRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/contact-details`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEmployeeContactDetailsRequestDto,
    signal,
  });
};

export const getUpdateEmployeeContactDetailsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeContactDetails>>,
    TError,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeContactDetailsRequestDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeeContactDetails>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeContactDetailsRequestDto;
  },
  TContext
> => {
  const mutationKey = ["updateEmployeeContactDetails"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeeContactDetails>>,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeContactDetailsRequestDto;
    }
  > = (props) => {
    const { nurseryId, userId, data } = props ?? {};

    return updateEmployeeContactDetails(nurseryId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeeContactDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeeContactDetails>>
>;
export type UpdateEmployeeContactDetailsMutationBody =
  UpdateEmployeeContactDetailsRequestDto;
export type UpdateEmployeeContactDetailsMutationError = void;

/**
 * @summary Replace an employee's Contact Details
 */
export const useUpdateEmployeeContactDetails = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeeContactDetails>>,
      TError,
      {
        nurseryId: string;
        userId: string;
        data: UpdateEmployeeContactDetailsRequestDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeContactDetails>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeContactDetailsRequestDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateEmployeeContactDetailsMutationOptions(options),
    queryClient,
  );
};
/**
 * Managers, group admins and platform admins; never on your own profile. Send every field: null clears one.
 * @summary Replace an employee's Emergency Contact
 */
export const updateEmployeeEmergencyContact = (
  nurseryId: string,
  userId: string,
  updateEmployeeEmergencyContactRequestDto: UpdateEmployeeEmergencyContactRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/emergency-contact`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEmployeeEmergencyContactRequestDto,
    signal,
  });
};

export const getUpdateEmployeeEmergencyContactMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeEmergencyContact>>,
    TError,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeEmergencyContactRequestDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeeEmergencyContact>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeEmergencyContactRequestDto;
  },
  TContext
> => {
  const mutationKey = ["updateEmployeeEmergencyContact"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeeEmergencyContact>>,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeEmergencyContactRequestDto;
    }
  > = (props) => {
    const { nurseryId, userId, data } = props ?? {};

    return updateEmployeeEmergencyContact(nurseryId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeeEmergencyContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeeEmergencyContact>>
>;
export type UpdateEmployeeEmergencyContactMutationBody =
  UpdateEmployeeEmergencyContactRequestDto;
export type UpdateEmployeeEmergencyContactMutationError = void;

/**
 * @summary Replace an employee's Emergency Contact
 */
export const useUpdateEmployeeEmergencyContact = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeeEmergencyContact>>,
      TError,
      {
        nurseryId: string;
        userId: string;
        data: UpdateEmployeeEmergencyContactRequestDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeEmergencyContact>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeEmergencyContactRequestDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateEmployeeEmergencyContactMutationOptions(options),
    queryClient,
  );
};
/**
 * Managers, group admins and platform admins; never on your own profile. Send every field: null clears one.
 * @summary Replace an employee's Additional Notes
 */
export const updateEmployeeAdditionalNotes = (
  nurseryId: string,
  userId: string,
  updateEmployeeAdditionalNotesRequestDto: UpdateEmployeeAdditionalNotesRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/additional-notes`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEmployeeAdditionalNotesRequestDto,
    signal,
  });
};

export const getUpdateEmployeeAdditionalNotesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeAdditionalNotes>>,
    TError,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeAdditionalNotesRequestDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeeAdditionalNotes>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeAdditionalNotesRequestDto;
  },
  TContext
> => {
  const mutationKey = ["updateEmployeeAdditionalNotes"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeeAdditionalNotes>>,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeAdditionalNotesRequestDto;
    }
  > = (props) => {
    const { nurseryId, userId, data } = props ?? {};

    return updateEmployeeAdditionalNotes(nurseryId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeeAdditionalNotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeeAdditionalNotes>>
>;
export type UpdateEmployeeAdditionalNotesMutationBody =
  UpdateEmployeeAdditionalNotesRequestDto;
export type UpdateEmployeeAdditionalNotesMutationError = void;

/**
 * @summary Replace an employee's Additional Notes
 */
export const useUpdateEmployeeAdditionalNotes = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeeAdditionalNotes>>,
      TError,
      {
        nurseryId: string;
        userId: string;
        data: UpdateEmployeeAdditionalNotesRequestDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeAdditionalNotes>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeAdditionalNotesRequestDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateEmployeeAdditionalNotesMutationOptions(options),
    queryClient,
  );
};
/**
 * Managers and group admins; never on your own profile. Platform admins and deputies cannot edit it. Send the whole list: it replaces the one stored, and an empty list clears it.
 * @summary Replace an employee's Allergies
 */
export const updateEmployeeAllergies = (
  nurseryId: string,
  userId: string,
  updateEmployeeAllergiesRequestDto: UpdateEmployeeAllergiesRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/allergies`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEmployeeAllergiesRequestDto,
    signal,
  });
};

export const getUpdateEmployeeAllergiesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeAllergies>>,
    TError,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeAllergiesRequestDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeeAllergies>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeAllergiesRequestDto;
  },
  TContext
> => {
  const mutationKey = ["updateEmployeeAllergies"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeeAllergies>>,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeAllergiesRequestDto;
    }
  > = (props) => {
    const { nurseryId, userId, data } = props ?? {};

    return updateEmployeeAllergies(nurseryId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeeAllergiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeeAllergies>>
>;
export type UpdateEmployeeAllergiesMutationBody =
  UpdateEmployeeAllergiesRequestDto;
export type UpdateEmployeeAllergiesMutationError = void;

/**
 * @summary Replace an employee's Allergies
 */
export const useUpdateEmployeeAllergies = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeeAllergies>>,
      TError,
      {
        nurseryId: string;
        userId: string;
        data: UpdateEmployeeAllergiesRequestDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeAllergies>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeAllergiesRequestDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateEmployeeAllergiesMutationOptions(options),
    queryClient,
  );
};
/**
 * Managers and group admins; never on your own profile. Platform admins and deputies cannot edit it. Send every field: null clears one. The "last updated" stamp is set by the server.
 * @summary Replace an employee's Health Information
 */
export const updateEmployeeHealthInformation = (
  nurseryId: string,
  userId: string,
  updateEmployeeHealthInformationRequestDto: UpdateEmployeeHealthInformationRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/health-information`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEmployeeHealthInformationRequestDto,
    signal,
  });
};

export const getUpdateEmployeeHealthInformationMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeHealthInformation>>,
    TError,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeHealthInformationRequestDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeeHealthInformation>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeHealthInformationRequestDto;
  },
  TContext
> => {
  const mutationKey = ["updateEmployeeHealthInformation"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeeHealthInformation>>,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeHealthInformationRequestDto;
    }
  > = (props) => {
    const { nurseryId, userId, data } = props ?? {};

    return updateEmployeeHealthInformation(nurseryId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeeHealthInformationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeeHealthInformation>>
>;
export type UpdateEmployeeHealthInformationMutationBody =
  UpdateEmployeeHealthInformationRequestDto;
export type UpdateEmployeeHealthInformationMutationError = void;

/**
 * @summary Replace an employee's Health Information
 */
export const useUpdateEmployeeHealthInformation = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeeHealthInformation>>,
      TError,
      {
        nurseryId: string;
        userId: string;
        data: UpdateEmployeeHealthInformationRequestDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeHealthInformation>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeHealthInformationRequestDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateEmployeeHealthInformationMutationOptions(options),
    queryClient,
  );
};
/**
 * Managers and group admins; never on your own profile. Platform admins and deputies cannot edit it. Send every field: null clears one.
 * @summary Replace an employee's Medication
 */
export const updateEmployeeMedication = (
  nurseryId: string,
  userId: string,
  updateEmployeeMedicationRequestDto: UpdateEmployeeMedicationRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/medication`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEmployeeMedicationRequestDto,
    signal,
  });
};

export const getUpdateEmployeeMedicationMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeMedication>>,
    TError,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeMedicationRequestDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmployeeMedication>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeMedicationRequestDto;
  },
  TContext
> => {
  const mutationKey = ["updateEmployeeMedication"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmployeeMedication>>,
    {
      nurseryId: string;
      userId: string;
      data: UpdateEmployeeMedicationRequestDto;
    }
  > = (props) => {
    const { nurseryId, userId, data } = props ?? {};

    return updateEmployeeMedication(nurseryId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmployeeMedicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmployeeMedication>>
>;
export type UpdateEmployeeMedicationMutationBody =
  UpdateEmployeeMedicationRequestDto;
export type UpdateEmployeeMedicationMutationError = void;

/**
 * @summary Replace an employee's Medication
 */
export const useUpdateEmployeeMedication = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmployeeMedication>>,
      TError,
      {
        nurseryId: string;
        userId: string;
        data: UpdateEmployeeMedicationRequestDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeMedication>>,
  TError,
  {
    nurseryId: string;
    userId: string;
    data: UpdateEmployeeMedicationRequestDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateEmployeeMedicationMutationOptions(options),
    queryClient,
  );
};
/**
 * Upload the image first (POST /v1/files/generate-upload-url with associatedEntityType USER, then PUT the file to the signed URL), then attach it here. The previous photo is deleted.
 * @summary Set an employee's profile photo
 */
export const setEmployeePhoto = (
  nurseryId: string,
  userId: string,
  setEmployeePhotoRequestDto: SetEmployeePhotoRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/photo`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: setEmployeePhotoRequestDto,
    signal,
  });
};

export const getSetEmployeePhotoMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setEmployeePhoto>>,
    TError,
    { nurseryId: string; userId: string; data: SetEmployeePhotoRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setEmployeePhoto>>,
  TError,
  { nurseryId: string; userId: string; data: SetEmployeePhotoRequestDto },
  TContext
> => {
  const mutationKey = ["setEmployeePhoto"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setEmployeePhoto>>,
    { nurseryId: string; userId: string; data: SetEmployeePhotoRequestDto }
  > = (props) => {
    const { nurseryId, userId, data } = props ?? {};

    return setEmployeePhoto(nurseryId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetEmployeePhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof setEmployeePhoto>>
>;
export type SetEmployeePhotoMutationBody = SetEmployeePhotoRequestDto;
export type SetEmployeePhotoMutationError = void;

/**
 * @summary Set an employee's profile photo
 */
export const useSetEmployeePhoto = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setEmployeePhoto>>,
      TError,
      { nurseryId: string; userId: string; data: SetEmployeePhotoRequestDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setEmployeePhoto>>,
  TError,
  { nurseryId: string; userId: string; data: SetEmployeePhotoRequestDto },
  TContext
> => {
  return useMutation(getSetEmployeePhotoMutationOptions(options), queryClient);
};
/**
 * The image is deleted. Succeeds when there is no photo.
 * @summary Remove an employee's profile photo
 */
export const removeEmployeePhoto = (
  nurseryId: string,
  userId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/photo`,
    method: "DELETE",
    signal,
  });
};

export const getRemoveEmployeePhotoMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeEmployeePhoto>>,
    TError,
    { nurseryId: string; userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeEmployeePhoto>>,
  TError,
  { nurseryId: string; userId: string },
  TContext
> => {
  const mutationKey = ["removeEmployeePhoto"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeEmployeePhoto>>,
    { nurseryId: string; userId: string }
  > = (props) => {
    const { nurseryId, userId } = props ?? {};

    return removeEmployeePhoto(nurseryId, userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveEmployeePhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeEmployeePhoto>>
>;

export type RemoveEmployeePhotoMutationError = void;

/**
 * @summary Remove an employee's profile photo
 */
export const useRemoveEmployeePhoto = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeEmployeePhoto>>,
      TError,
      { nurseryId: string; userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeEmployeePhoto>>,
  TError,
  { nurseryId: string; userId: string },
  TContext
> => {
  return useMutation(
    getRemoveEmployeePhotoMutationOptions(options),
    queryClient,
  );
};
/**
 * Active managers and deputy managers at the nursery, excluding the employee. For callers who can edit the profile.
 * @summary Who can be picked as this employee's line manager
 */
export const listLineManagerCandidates = (
  nurseryId: string,
  userId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<LineManagerCandidateResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/people/${userId}/line-manager-candidates`,
    method: "GET",
    signal,
  });
};

export const getListLineManagerCandidatesQueryKey = (
  nurseryId: string,
  userId: string,
) => {
  return [
    `/v1/nurseries/${nurseryId}/people/${userId}/line-manager-candidates`,
  ] as const;
};

export const getListLineManagerCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLineManagerCandidates>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListLineManagerCandidatesQueryKey(nurseryId, userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLineManagerCandidates>>
  > = ({ signal }) => listLineManagerCandidates(nurseryId, userId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      nurseryId !== null &&
      nurseryId !== undefined &&
      userId !== null &&
      userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listLineManagerCandidates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListLineManagerCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLineManagerCandidates>>
>;
export type ListLineManagerCandidatesQueryError = void;

export function useListLineManagerCandidates<
  TData = Awaited<ReturnType<typeof listLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLineManagerCandidates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLineManagerCandidates>>,
          TError,
          Awaited<ReturnType<typeof listLineManagerCandidates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLineManagerCandidates<
  TData = Awaited<ReturnType<typeof listLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLineManagerCandidates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLineManagerCandidates>>,
          TError,
          Awaited<ReturnType<typeof listLineManagerCandidates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLineManagerCandidates<
  TData = Awaited<ReturnType<typeof listLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLineManagerCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Who can be picked as this employee's line manager
 */

export function useListLineManagerCandidates<
  TData = Awaited<ReturnType<typeof listLineManagerCandidates>>,
  TError = void,
>(
  nurseryId: string,
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLineManagerCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListLineManagerCandidatesQueryOptions(
    nurseryId,
    userId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
